<template>
	<li v-if="!hide">
		<a
			:href="url"
			:target="target"
			:rel="rel"
			class="no-submenu link-menu"
			:class="className"
			@click="clicked"
		>
			<img
				v-if="imagePath"
				:src="imagePath"
				:alt="title"
				:class="className"
			/>
			{{ title }}
		</a>
		<div v-if="description">{{ description }}</div>
	</li>
</template>
<script>
export default {
	name: 'Link',
	props: {
		title: String,
		url: { type: String, default: '#' },
		target: { type: String, default: '_self' },
		rel: { type: String, default: 'noopener noreferrer' },
		image: { type: String, default: null },
		className: { type: String, default: '' },
		hide: Boolean,
		method: String,
		description: String,
	},
	computed: {
		imagePath() {
			return this.image
				? require('../../assets/img/' + this.image)
				: false
		},
	},
	methods: {
		clicked() {
			if (this.method) {
				this.$emit(this.method)
			}
		},
	},
}
</script>

<style scoped lang="scss">
a {
	&.lang {
		width: 36px;
		text-align: center;
		margin-top: -4px;
		border: 2px solid $greenTheme;
		text-transform: uppercase;
		padding: 4px;
	}
}

.content-footerlink {
	a {
		font-weight: 600;

		&.secondary {
			font-weight: normal;
			text-transform: uppercase;
		}

		&:after {
			@include effect(width, 0.5s, ease);
			display: block;
			position: relative;
			content: '';
			width: 0;
			background: $greenTheme;
			margin: 0 auto 4px;
			height: 2px;
		}

		@include nomobile {
			&.active,
			&:hover,
			&:focus {
				&:after {
					@include effect(width, 0.5s, ease);
					width: 100%;
				}
			}
		}
	}
}

img {
	height: 25px;
	width: auto;
	padding: 0;

	&.contact {
		height: 20px;
		padding-right: 5px;
	}
}
</style>
